import { useQuery } from "react-query";
import { getVendorById } from "../../../../actions/CarrierAgreementMgmt/Vendor";

export const useGetVendorById = (officeId) => {
  return useQuery(["GetVendorById ", officeId], () => getVendorById(officeId), {
    refetchOnWindowFocus: false,
  });
};
